import PropTypes from "prop-types";
import React, { Component } from "react";

const notificationClassMap = new Map([
  ["notification", "p-notification--information"],
  ["error", "p-notification--negative"]
]);

class Notification extends Component {
  state = {
    interval: undefined
  };

  componentDidMount = () => {
    const { timer } = this.props;
    if (timer) {
      const interval = setInterval(this.dismissNotification, timer);
      this.setState({ interval });
    }
  };

  componentWillUnmount = () => {
    const { interval } = this.state;
    clearInterval(interval);
  };

  dismissNotification = () => {
    const { id, onDismiss } = this.props;
    if (onDismiss && id) {
      onDismiss(id);
    }
  };

  render() {
    const {
      action,
      type,
      status,
      message,
      dismissable,
      id,
      onDismiss
    } = this.props;

    return (
      <div className={notificationClassMap.get(type) || "p-notification"}>
        <p className="p-notification__response">
          {status && <span className="p-notification__status">{status}</span>}
          {message}
          {action && (
            <span
              role="button"
              tabIndex="0"
              className="p-notification__action"
              onClick={() => action.func(id)}
              onKeyPress={() => action.func(id)}
            >
              {action.text}
            </span>
          )}
        </p>
        {dismissable && onDismiss ? (
          <button
            type="button"
            className="p-icon--close"
            onClick={this.dismissNotification}
          >
            Close
          </button>
        ) : null}
      </div>
    );
  }
}

Notification.propTypes = {
  id: PropTypes.string,
  dismissable: PropTypes.bool,
  onDismiss: PropTypes.func,
  message: PropTypes.string.isRequired,
  status: PropTypes.string,
  type: PropTypes.oneOf(["notification", "error", ""]),
  action: PropTypes.shape({
    text: PropTypes.string.isRequired,
    func: PropTypes.func.isRequired
  }),
  timer: PropTypes.number
};

Notification.defaultProps = {
  id: undefined,
  dismissable: true,
  onDismiss: undefined,
  status: "",
  type: "",
  action: undefined,
  timer: undefined
};

export default Notification;
